document.addEventListener("DOMContentLoaded", function () {
  const tabLinks = document.querySelectorAll(".tab-link");
  const tabContents = document.querySelectorAll(".tab-content");

  tabLinks.forEach(function (tab) {
    tab.addEventListener("click", function () {
      const target = this.getAttribute("data-tab");

      tabLinks.forEach(t => t.classList.remove("current"));
      tabContents.forEach(c => c.classList.remove("current"));

      this.classList.add("current");
      document.getElementById(target).classList.add("current");
    });
  });
});
